// Groot Gıda — Fiyat Teklifi (Birim Fiyat / Müşteriye Özel) A4 yazdırma + WhatsApp.
import { logoUrl, docBrandName, docSlogan, docLegalName, docAddress, docTaxLine, docPhone, docEmail, docStampUrl, docImageUrl, docStampPos, activeDocTemplate, symbolForCurrency } from "@/lib/company";

const money = (v, sym) => {
  if (v === null || v === undefined || v === "" || isNaN(Number(v))) return "—";
  return Number(v).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " " + (sym || "₺");
};
const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const dt = (iso) => { try { return new Date(iso).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" }); } catch { return "—"; } };

function kvBlock(title, pairs) {
  const rows = pairs.filter(([, v]) => v && String(v).trim()).map(([k, v]) => `<div class="kv"><span class="k">${esc(k)}</span><span class="v">${esc(v)}</span></div>`).join("");
  if (!rows) return "";
  return `<div class="sec"><div class="sech">${esc(title)}</div>${rows}</div>`;
}

function itemsRows(q, sym) {
  return (q.items || []).map((l) => `
    <tr>
      <td><b>${esc(l.name || "")}</b>${l.sku ? `<span class="sku"> ${esc(l.sku)}</span>` : ""}</td>
      <td class="sm">${esc(l.pack || "—")}</td>
      <td class="c">${esc(l.unit || "—")}</td>
      <td class="r">${money(l.price_cash, sym)}</td>
      <td class="r">${money(l.price_30, sym)}</td>
      <td class="r">${money(l.price_45, sym)}</td>
      <td class="r hl">${money(l.price_60, sym)}</td>
    </tr>`).join("");
}

const CSS = `
  * { box-sizing:border-box; }
  body { font-family:Arial,"Segoe UI",sans-serif; color:#0f172a; margin:0; font-size:11.5px; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
  .page { padding:11mm; }
  .hd { display:flex; justify-content:space-between; align-items:flex-start; border-bottom:3px solid #064E3B; padding:10px 14px; margin-bottom:12px; background:linear-gradient(90deg,#ECFDF5,#ffffff); border-radius:10px 10px 0 0; }
  .brand { display:flex; align-items:center; gap:12px; }
  .dlogo { height:46px; width:auto; display:block; }
  .brand .bn { font-size:19px; font-weight:800; color:#064E3B; letter-spacing:.3px; }
  .brand .sl { font-size:10px; font-weight:700; color:#EA580C; letter-spacing:.5px; margin-top:2px; }
  .brand .sl2 { font-size:9px; color:#64748b; margin-top:1px; }
  .doc-title { text-align:right; }
  .doc-title .t1 { font-size:16px; color:#064E3B; font-weight:800; letter-spacing:.3px; }
  .doc-title .t2 { display:inline-block; margin-top:3px; padding:2px 9px; border-radius:999px; background:#EA580C; color:#fff; font-size:9px; font-weight:800; letter-spacing:1px; }
  .doc-title .t3 { font-size:10px; color:#64748b; margin-top:3px; }
  .doc-title .no { font-family:monospace; font-size:13px; font-weight:700; color:#0f172a; margin-top:4px; }
  .doc-title .vl { font-size:11px; color:#8a6d00; font-weight:700; margin-top:2px; }
  .co { font-size:10px; color:#475569; line-height:1.5; margin:0 0 10px; padding:6px 10px; border-left:3px solid #EA580C; background:#fff7ed; border-radius:0 6px 6px 0; }
  .co b { color:#0f172a; }
  .cust { border:1px solid #f0c99a; background:#fff7ed; border-left:4px solid #EA580C; border-radius:8px; padding:8px 12px; margin-bottom:10px; }
  .cust .lbl { font-size:9px; text-transform:uppercase; letter-spacing:1px; color:#EA580C; font-weight:800; margin-bottom:3px; }
  .cust .grid { display:flex; flex-wrap:wrap; gap:2px 26px; }
  .cust .kv { display:flex; gap:6px; font-size:11px; min-width:46%; }
  .cust .kv .k { color:#64748b; min-width:78px; } .cust .kv .v { color:#0f172a; font-weight:600; }
  .fnote { font-size:10px; color:#064E3B; font-weight:700; margin:0 0 4px; }
  table.items { width:100%; border-collapse:collapse; }
  table.items th, table.items td { border:1px solid #cfd8d3; padding:5px 6px; vertical-align:top; }
  table.items th { background:#e8f1ec; color:#064E3B; text-align:left; font-size:9.5px; text-transform:uppercase; letter-spacing:.2px; border-color:#064E3B; }
  table.items td.c { text-align:center; } table.items td.r { text-align:right; } table.items td.hl { color:#047857; font-weight:800; }
  table.items .sku { font-family:monospace; font-size:9px; color:#94a3b8; } table.items td.sm { font-size:10px; color:#475569; }
  .tnote { font-size:9.5px; color:#94a3b8; margin:6px 0 12px; }
  .cols { display:flex; gap:12px; }
  .cols > div { flex:1; }
  .sec { border:1px solid #d5e0da; border-radius:8px; padding:7px 10px; margin-bottom:8px; }
  .sec .sech { font-size:10px; text-transform:uppercase; letter-spacing:.6px; color:#064E3B; font-weight:800; border-bottom:1px solid #e2e8f0; padding-bottom:3px; margin-bottom:4px; }
  .sec .kv { display:flex; justify-content:space-between; gap:8px; padding:2px 0; font-size:10.5px; }
  .sec .kv .k { color:#64748b; } .sec .kv .v { color:#0f172a; font-weight:600; text-align:right; }
  .terms { margin-top:8px; }
  .terms .th { font-size:10px; text-transform:uppercase; letter-spacing:.6px; color:#064E3B; font-weight:800; margin-bottom:4px; }
  .terms p { font-size:10px; color:#475569; line-height:1.55; margin:0 0 5px; padding-left:10px; border-left:2px solid #cbd5e1; }
  .terms p b { color:#0f172a; }
  .sign { display:flex; gap:16px; margin-top:16px; align-items:flex-end; }
  .sign > div { flex:1; }
  .sline { border-top:1px solid #334155; margin-bottom:5px; height:34px; }
  .sc { font-size:10px; color:#475569; text-align:center; }
  .dstamp { display:inline-block; transform:rotate(-5deg); border:2px solid #064E3B; color:#064E3B; border-radius:8px; padding:6px 14px; font-size:10px; font-weight:800; letter-spacing:1.5px; line-height:1.4; text-align:center; }
  .ft { margin-top:14px; padding-top:6px; border-top:2px solid #064E3B; font-size:9.5px; color:#64748b; display:flex; justify-content:space-between; }
  .ft b { color:#064E3B; }
  body[data-template="minimal"] .hd { background:#fff; border-bottom:2px solid #0A0A0A; }
  body[data-template="minimal"] table.items th { background:#fff; color:#0A0A0A; border-color:#0A0A0A; }
  @page { size:A4; margin:0; }
`;

export function buildQuoteHTML(q) {
  if (!q) return "";
  const ci = q.customer_info || {};
  const sym = symbolForCurrency(q.currency);
  const dv = q.delivery || {}; const st = q.standard || {}; const bk = q.bank || {};
  const stampPos = docStampPos();
  const stamp = docStampUrl()
    ? `<img src="${docImageUrl(docStampUrl())}" alt="Kaşe & İmza" style="max-height:74px;max-width:160px;display:inline-block;"/>`
    : `<span class="dstamp">GÜVEN & TAZELİK<br/><small style="font-size:8px;letter-spacing:1px;">${esc(docBrandName())}</small></span>`;

  const body = `<section class="page">
    <div class="hd">
      <div class="brand"><img class="dlogo" src="${logoUrl()}" alt="${esc(docBrandName())}"/>
        <div><div class="bn">${esc(docBrandName())}</div><div class="sl">${esc(docSlogan() || "İş Ortaklığında Güven ve Tazelik")}</div><div class="sl2">Toptan Meyve, Sebze, Yeşillik ve Tropikal Tedariği</div></div>
      </div>
      <div class="doc-title">
        <div class="t1">FİYAT TEKLİFİ</div>
        <div class="t2">MÜŞTERİYE ÖZEL</div>
        <div class="t3">Birim Fiyat Teklifi</div>
        <div class="no">${esc(q.quote_no || "")} · Rev.${esc(q.rev || "00")}</div>
        ${q.valid_until ? `<div class="vl">Geçerlilik: ${esc(q.valid_until)}</div>` : `<div class="t3">Tarih: ${dt(q.created_at)}</div>`}
      </div>
    </div>

    <div class="co"><b>${esc(docLegalName())}</b> · ${esc(docAddress())} · ${esc(docTaxLine())} · Tel: ${esc(docPhone())} · ${esc(docEmail())}</div>

    <div class="cust">
      <div class="lbl">Müşteri Bilgileri</div>
      <div class="grid">
        <div class="kv"><span class="k">Firma</span><span class="v">${esc(q.customer_name || "—")}</span></div>
        <div class="kv"><span class="k">Yetkili</span><span class="v">${esc(ci.yetkili || "—")}</span></div>
        <div class="kv"><span class="k">Telefon</span><span class="v">${esc(ci.phone || "—")}</span></div>
        <div class="kv"><span class="k">E-posta</span><span class="v">${esc(ci.email || "—")}</span></div>
        <div class="kv" style="min-width:98%"><span class="k">Teslim adresi</span><span class="v">${esc(ci.teslim_adresi || ci.address || "—")}</span></div>
        ${ci.tax_no ? `<div class="kv"><span class="k">VKN/TCKN</span><span class="v">${esc(ci.tax_no)}</span></div>` : ""}
      </div>
    </div>

    <p class="fnote">FİYATLAR: ${esc(q.kdv_note || "%1 KDV DAHİLDİR")} · Para Birimi: ${esc(q.currency || "TL")}</p>
    <table class="items">
      <thead><tr>
        <th style="width:26%">Ürün Adı</th><th style="width:22%">Standart / Ambalaj</th><th style="width:9%">Satış Birimi</th>
        <th style="width:11%" class="r">Peşin</th><th style="width:11%" class="r">30 Gün</th><th style="width:11%" class="r">45 Gün</th><th style="width:11%" class="r">60 Gün</th>
      </tr></thead>
      <tbody>${itemsRows(q, sym)}</tbody>
    </table>
    <p class="tnote">Ürün satırları netleştirilir; gramaj, ambalaj, satış birimi ve fiyatlar teklif öncesinde teyit edilir. Fiyat girilmeyen vade sütunu teklif kapsamı dışındadır. Vadeli çalışma yazılı cari hesap onayıyla kesinleşir.</p>

    <div class="cols">
      <div>
        ${kvBlock("Teslimat ve Ticari Bilgiler", [["Teslim şekli", dv.teslim_sekli], ["Bölge ve termin", dv.bolge_termin], ["Minimum sipariş", dv.min_siparis], ["Nakliye", dv.nakliye]])}
        ${kvBlock("Banka Bilgileri", [["Banka / şube", bk.banka_sube], ["Hesap sahibi", bk.hesap_sahibi], ["IBAN", bk.iban], ["Ödeme açıklaması", bk.odeme_aciklamasi]])}
      </div>
      <div>
        ${kvBlock("Ürün Standardı", [["Menşe / sınıf", st.urun_standardi]])}
        ${kvBlock("Teslim Programı", [["Program", st.teslim_programi]])}
        ${kvBlock("Kalite ve Kabul", [["Bildirim", st.kalite_kabul]])}
      </div>
    </div>

    <div class="terms">
      <div class="th">Ticari Koşullar ve Sipariş Teyidi</div>
      <p><b>Fiyat kapsamı:</b> Teklif yalnız belirtilen ürün standardı ve geçerlilik süresi içindir. Süre sonunda fiyat ve stok yeniden teyit edilir.</p>
      <p><b>Teslim ve kontrol:</b> Ürün alternatifi müşteri onayıyla belirlenir. Miktar, ambalaj ve görünür kalite teslimde kontrol edilir; uygunsuzluk belirtilen süre ve kanaldan bildirilir. Çözüm yazılı olarak teyit edilir.</p>
      <p><b>Sipariş toplamı:</b> Bu belge birim fiyat teklifidir. Kesin miktarlar, seçilen vade, KDV, nakliye ve depozito ile toplam bedel ayrıca yazılı sipariş teyidinde gösterilir.</p>
      ${q.notes ? `<p><b>Not:</b> ${esc(q.notes)}</p>` : ""}
    </div>

    <div class="sign">
      <div class="sc"><div class="sline"></div>Hazırlayan<br/>${esc(q.prepared_by || docBrandName())}</div>
      <div style="text-align:${stampPos === "top" ? "center" : stampPos}">${stamp}</div>
      <div class="sc"><div class="sline"></div>Seçilen vade / teyit<br/>${esc(q.vade_teyit || "Vade / yetkili / tarih")}</div>
    </div>

    <div class="ft"><span>${esc(docLegalName())}</span><span>Tel: ${esc(docPhone())} · ${esc(docEmail())} · <b>${esc(docBrandName())}</b></span></div>
  </section>`;
  return `<!doctype html><html lang="tr"><head><meta charset="utf-8"><title>${esc(q.quote_no || "Teklif")}</title><style>${CSS}</style></head><body data-template="${activeDocTemplate()}">${body}</body></html>`;
}

export function printQuote(q) {
  const html = buildQuoteHTML(q);
  if (!html) return false;
  const w = window.open("", "_blank", "width=980,height=1000");
  if (!w) return false;
  w.document.open(); w.document.write(html); w.document.close(); w.focus();
  setTimeout(() => { try { w.print(); } catch (e) { /* kullanıcı kapatmış olabilir */ } }, 600);
  return true;
}

export function whatsappQuote(q) {
  if (!q) return;
  const sym = symbolForCurrency(q.currency);
  const lines = (q.items || []).map((l) => {
    const p = [l.price_cash != null && l.price_cash !== "" ? `Peşin ${money(l.price_cash, sym)}` : "", l.price_30 ? `30g ${money(l.price_30, sym)}` : "", l.price_45 ? `45g ${money(l.price_45, sym)}` : "", l.price_60 ? `60g ${money(l.price_60, sym)}` : ""].filter(Boolean).join(" · ");
    return `• ${l.name}${l.unit ? ` (${l.unit})` : ""}: ${p || "—"}`;
  }).join("\n");
  const text = `*${docBrandName()}* — FİYAT TEKLİFİ (Müşteriye Özel)\nTeklif No: ${q.quote_no} Rev.${q.rev || "00"}\nFirma: ${q.customer_name}${q.customer_info?.yetkili ? ` / ${q.customer_info.yetkili}` : ""}${q.valid_until ? `\nGeçerlilik: ${q.valid_until}` : ""}\nFiyatlar: ${q.kdv_note || "%1 KDV DAHİLDİR"}\n\n${lines}\n\n${q.notes ? `Not: ${q.notes}\n` : ""}${docBrandName()} · ${docPhone()}`;
  const phone = (q.customer_info?.phone || "").replace(/\D/g, "");
  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(text)}`, "_blank");
}
